"use client";

export function CookieSettings(props: React.ComponentPropsWithoutRef<"button">) {
  return (
    <button
      type='button'
      onClick={() => {
        window.Cookiebot?.renew?.();
      }}
      {...props}
    />
  );
}
